<template>
  <div>
    <el-container>
      <el-main style="padding: 0; display: flex">
        <div style="width: 910px">
          <span>关键元器件扫描</span>
          <el-divider/>
          <el-form
              ref="form"
              v-loading="submitLoading"
              style="width: 550px"
              :rules="ruleValidate"
              :model="model"
              class="form"
              label-width="90px"
              @submit.native.prevent>
            <!--          <el-form-item label="生产工单" prop="orderNo">-->
            <!--            <el-input-->
            <!--                ref="orderNoInput"-->
            <!--                v-model="model.orderNo"-->
            <!--                placeholder="请扫生产工单号"-->
            <!--                size="mini"-->
            <!--                @keyup.enter.native.stop="orderNoScan"/>-->
            <!--          </el-form-item>-->
            <!--          <el-form-item label="工序" prop="operationNo">-->
            <!--            <el-select-->
            <!--                v-model="model.operationNo"-->
            <!--                placeholder="请选择工序"-->
            <!--                @change="processChange">-->
            <!--              <el-option-->
            <!--                  v-for="item in form.routingList"-->
            <!--                  :key="item.pkId"-->
            <!--                  :label="item.procedureName"-->
            <!--                  :value="item.operationNo"/>-->
            <!--            </el-select>-->
            <!--          </el-form-item>-->
            <el-form-item label="序列号" prop="snSerialNo">
              <el-input
                  ref="snSerialNoInput"
                  v-model="model.snSerialNo"
                  placeholder="请扫描序列号"
                  size="mini"
                  @keyup.enter.native.stop="snSerialNoChange"/>
            </el-form-item>
          </el-form>
          <span>扫描记录</span>
          <el-divider/>
          <el-table
              style="width: 1200px"
              border
              stripe
              height="calc(50vh - 130px)"
              :data="model.keyMaterial">
            <el-table-column type="index" align="center" label="#"/>
            <el-table-column prop="barcode" align="center" width="180" label="主条码"/>
            <el-table-column prop="productionOrderNo" align="center" width="100" label="工单号"/>
            <el-table-column prop="materialNo" align="center" width="100" label="物料号"/>
            <el-table-column prop="componentMaterialNo" align="center" width="100" label="部件物料号"/>
            <el-table-column prop="componentBarcode" align="center" width="180" label="部件条码"/>
            <el-table-column prop="operatorName" align="center" width="60" label="扫描人"/>
            <el-table-column prop="createTime" align="center" label="扫描时间"/>
          </el-table>
        </div>
        <!-- 历史扫码记录 -->
        <scan-history-comp
            ref="scanHistoryComp"
            title="历史扫码记录"
            storage-key-prefix="KeyComponents"
            :delete-auth-index="757"
        />
      </el-main>
    </el-container>
    <!-- 订单信息 -->
    <order-infor-comp ref="orderInforComp" left-width="910px"/>
  </div>
</template>

<script>
  import ScanHistoryComp from "./ScanHistoryComp.vue";
  import OrderInforComp from "./OrderInforComp.vue";
  export default {
    name: "KeyComponents",
    components: {ScanHistoryComp, OrderInforComp},

    data() {
      return {
        submitLoading: false,
        getDataLoading: false,
        complete: false,
        confirmationRecord: [],
        form: {
          routingList: [],
        },
        model: {
          orderNo: "",
          operationNo: "",
          snSerialNo: "",
          keyMaterial: [],
        },
        ruleValidate: {
          orderNo: [{required: true, message: "请扫描工单号", trigger: "blur"}],
          operationNo: [{required: true, message: "请选择工序", trigger: "blur"}],
          snSerialNo: [{required: true, message: "请扫描序列号", trigger: "blur"}],
        },
      };
    },

    methods: {
      orderNoScan() {
        if (this.model.orderNo) {
          this.submitLoading = true;
          this.$http.get("basic", `sapProductionOrders/getByNo/${this.model.orderNo}`).then((res) => {
            if (res.success) {
              this.submitLoading = false;
              this.form = res.data;
              this.$playScanSuccess();
            } else {
              this.submitLoading = false;
              // this.$refs.form.resetFields();
              this.$playScanFailure();
            }
          });
        }
      },
      processChange() {
        this.$refs.snSerialNoInput.focus();
      },
      snSerialNoChange() {
        if (this.model.snSerialNo === "") {
          return this.$message.error("请输入序列号");
        }else {
          let params = {
            snSerialNo: this.model.snSerialNo.replace(/\s/g, ""),
            keyMaterial: this.model.keyMaterial,
          };
          if(this.submitLoading) return;
          this.submitLoading = true;
          this.$http.post("basic", "sapProductionOrders/confirmAssembleKeyMaterial", params).then((res) => {
            if (res.success) {
              // 保存条形码到历史记录,保留明细中第一条数据的主数据
              if (this.$refs.scanHistoryComp && res.data.keyMaterial.length > 0) {
                this.$refs.scanHistoryComp.saveBarcode(res.data.keyMaterial[0].barcode);
              }
              if (this.$refs.orderInforComp) {
                this.$refs.orderInforComp.getData(res.data.billNo);
              }
              this.model.keyMaterial = res.data.keyMaterial;
              this.model.snSerialNo="";
              this.submitLoading = false;
              this.$playScanSuccess();
            } else {
              this.$refs.form.resetFields();
              this.submitLoading = false;
              this.$playScanFailure();
            }
          }).catch(() => {
            this.submitLoading = false;
          });
        }
      },
    },
  };
</script>
<style scoped lang="scss">
::v-deep .el-container {
  height: 50vh;
}
</style>

